import { CONFIG } from "@/config.js";

export default {
    methods: {
        verifyVersion: function(version, required) {
            if (!required) {
                return true
            }
            if (!version) {
                return false
            }

            let versions = ['teaser', 'lite', 'full']
            return versions.indexOf(required) <= versions.indexOf(version)
        },
        order: function(name, ico, version) {
            window.location =
                `${CONFIG.apiBaseUrl}?name=${encodeURIComponent(name)}&ico=${encodeURIComponent(ico)}&version=${encodeURIComponent(version)}`
        }
    }
}